import { render, staticRenderFns } from "./PopupPprHistory.vue?vue&type=template&id=33cbc415&"
import script from "./PopupPprHistory.vue?vue&type=script&lang=js&"
export * from "./PopupPprHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports